import React, { Fragment } from 'react'
import { Grid, Box, Typography,  Card, Stack } from "@mui/material";
import { useResponsive } from '../../../hooks/use-responsive';
import './referAndEarn.css'

function ReferEarnHowItWorks() {
    const mdUp = useResponsive("up", "md");


    return (
        <Fragment  >
            <Box
                sx={{

                    padding: { xl: '64px', md: '64px', xs: '28px 24px' },
                    backgroundColor: '#F1F1F1',

                }}
            >
                <Grid
                    container
                    spacing={3}
                    sx={{ justifyContent: "center", alignContent: "center", }}
                >
                    {mdUp && <Grid item md={8} spacing={2} alignItems="center"  >
                        <Typography marginBottom={1} className="HeroHeadingNewRNE"
                            textAlign='center'>
                            How it Works in
                            <span className='HeroHeadingItalic' style={{ color: '#1E53E8', }} >  4 Steps </span>
                        </Typography>
                        <Typography className="heroTextNewRnE" textAlign='center' >
                            Joining MegaConnect's Refer & Earn Program is simple! Just follow these four
                            steps to start sharing the benefits of a secure, high-speed cloud PC and earn
                            rewards effortlessly.
                        </Typography>
                    </Grid>}
                    {!mdUp && <Grid item xs={12} md={8} alignItems="center"  >
                        <Typography marginBottom={1} className="HeroHeadingNewRNE"
                            textAlign='center' >
                            How it Works in
                            <span className='HeroHeadingItalic' style={{ color: '#1E53E8', }} >  4 Steps </span>
                        </Typography>

                        <Typography className="heroTextNewRnE" textAlign='center'>
                            Joining MegaConnect's Refer & Earn Program is simple! Just follow these four
                            steps to start sharing the benefits of a secure, high-speed cloud PC and earn
                            rewards effortlessly.
                        </Typography>
                    </Grid>}

                </Grid>
                <Box sx={{
                    display: 'grid',
                    rowGap: 4,
                    columnGap: 4,
                    padding: { sm: '0 6px' },
                    mt: { md: '38px', xs: '26px' },

                    gridTemplateColumns: {
                        xs: "repeat(1, 1fr)",   // iPhone Mini (small screens)
                        sm: "repeat(1, 1fr)",   // For screens like iPad mini (768px)
                        md: "repeat(2, 1fr)",
                    },
                }}>
                    <Card sx={{ p: '24px', borderRadius: 5, spacing: 2,boxShadow:'none'  }}>
                        <Stack spacing={1}>
                            <Typography className='RnECardTitle' justifyContent='left'>Step: 1</Typography>
                            <Typography className='RnECardSubTitle' justifyContent='left'>Find Your Referral Code</Typography>
                            <Typography className='RnECardText' justifyContent='left'>Sign Up with MegaConnect account, and Go to the "Refer & Earn" section of your dashboard and get your unique referral code (Example: MEGA801).
                            </Typography>
                        </Stack>
                    </Card>
                    <Card sx={{ p: '24px', borderRadius: 5, spacing: 2,boxShadow:'none'  }}>
                        <Stack spacing={1}>
                            <Typography className='RnECardTitle' justifyContent='left'>Step: 2</Typography>
                            <Typography className='RnECardSubTitle' justifyContent='left'>Share Your Referral Code with Friends</Typography>
                            <Typography className='RnECardText' justifyContent='left'>
                                Tell your friends about MegaConnect Cloud PC, when they apply the Coupon Code during their first payment, they’ll get an instant 50% discount
                            </Typography>
                        </Stack>
                    </Card>
                    <Card sx={{ p: '24px', borderRadius: 5, spacing: 2,boxShadow:'none'  }}>
                        <Stack spacing={1}>
                            <Typography className='RnECardTitle' justifyContent='left'>Step: 3</Typography>
                            <Typography className='RnECardSubTitle' justifyContent='left'>Your Friend Gets Flat 50% Instant Off</Typography>
                            <Typography className='RnECardText' justifyContent='left'>
                                They get a flat 50% instant discount on their first payment when they use your referral code.
                            </Typography>
                        </Stack>
                    </Card>
                    <Card sx={{ p: '24px', borderRadius: 5, spacing: 2,boxShadow:'none'  }}>
                        <Stack spacing={1}>
                            <Typography className='RnECardTitle' justifyContent='left'>Step: 4</Typography>
                            <Typography className='RnECardSubTitle' justifyContent='left'>You Get Flat 50% Cashback</Typography>
                            <Typography className='RnECardText' justifyContent='left'>
                                Earn Flat 50% Cashback when they apply your referral code and complete
                                their first payment. You can also check all your referral rewards in the
                                "Dashboard - Refer & Earn" section.
                            </Typography>
                        </Stack>
                    </Card>
                </Box>
            </Box>
        </Fragment>
    )
}

export default ReferEarnHowItWorks
